import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 460px;
	padding: 30px;
	background-color: #111314;
	border-radius: 10px;
	border: 1px solid rgba(255, 255, 255, 0.1);
`;

const StyledHead = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;

	${Text} {
		font-weight: 700;
		font-size: 18px;
		color: #ffffff;
	}
`;

const StyledTextAreaContainer = styled.div`
	position: relative;
	margin-top: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);
	border-radius: 5px;
	padding: 20px;
`;

const StyledTextArea = styled.textarea`
	width: 330px;
	height: 163px;
	background-color: transparent;
	border: none;
	outline: none;
	resize: none;
	overflow-y: scroll;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 16px;
	color: #ffffff;

	&:placeholder {
		color: rgba(255, 255, 255, 0.25);
	}

	&::-webkit-scrollbar {
		display: none;
	}
	scrollbar-width: none;
`;

const StyledTextAreaStatsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 10px;
	user-select: none;
	cursor: text;
`;

export {
	StyledContainer,
	StyledHead,
	StyledTextArea,
	StyledTextAreaContainer,
	StyledTextAreaStatsContainer,
};
